import React from 'react';
import { Modal, Form, Input, Select } from 'antd';
import { requiredField } from '../../../models/formValidator';
import { submitFormData } from '../../../HOCs';
import { createAgency } from './agency.ducks';
import { ImportMappingType } from '../../../models/enums';

const defaultSettings = {
  formValidator: {
    url: [requiredField('url')],
    xml: [requiredField('xml')],
    email: [requiredField('email')],
  },
};

// eslint-disable-next-line max-lines-per-function
function AgencyPopup({
  visible,
  onCancel,
  onCreate,
  onSubmit,
  form,
  settings,
  loading,
}) {
  const handleCancel = () => {
    onCancel();
    form.resetFields();
  };

  const handleOk = (e) => {
    e.preventDefault();
    form.validateFields((err, values) => {
      if (!err) {
        onCreate(values, onSubmit, () => form.resetFields());
      }
    });
  };

  const getPopupContainer = (trigger) => trigger.parentNode;

  return (
    <Modal
      title={"Dodajte agenciju"}
      visible={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={loading}
      okText={"Kreiraj"}
      cancelText={"Odustani"}
    >
      <Form layout="vertical">
        <Form.Item label={"E-mail"}>
          {form.getFieldDecorator('email', {
            rules: settings.formValidator.email,
          })(
            <Input
              placeholder={"E-mail"}
            />,
          )}
        </Form.Item>
        <Form.Item label={"XML format"}>
          {form.getFieldDecorator('mapperType', {
            rules: settings.formValidator.xml,
          })(
            <Select getPopupContainer={getPopupContainer} placeholder={"XML format"}>
              {ImportMappingType.map(format => (
                <Select.Option key={format.value} value={format.value}>
                  {format.name}
                </Select.Option>
              ))}
            </Select>,
          )}
        </Form.Item>
        <Form.Item label={"URL"}>
          {form.getFieldDecorator('sourceUrl', {
            rules: settings.formValidator.url,
          })(
            <Input placeholder={"URL"} />,
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
}

AgencyPopup.defaultProps = {
  visible: false,
  settings: defaultSettings,
  loading: false,
};

export default submitFormData(Form.create()(AgencyPopup), createAgency);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageAgencyPage/AgencyPopup.tsx